import { HoverText } from '@campfire/hover-link';
import { TabletButton } from '@campfire/tablet-button';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { EventNote, Group } from '@material-ui/icons';
import React from 'react';
import { useFormBuilderDialogContext } from './FormBuilderDialogContext';

interface TaskControlsContentProps {
  taskType?: string;
}

export const TaskControlsContent = ({ taskType }: TaskControlsContentProps) => {
  const { addHeading, addContent, addField, addMedia, addPageBreak } = useFormBuilderDialogContext();

  const getContent = () => {
    if (taskType === 'event') {
      return {
        title: 'Event Configuration',
        description: 'Configure your scheduled event and any required information',
        buttonText: 'Add Event Field',
        helpText:
          'Add fields and instructions for the event. These will be visible to coordinators and participants to help structure the session.',
      };
    }

    if (taskType === 'referee_check') {
      return {
        title: 'Referee Check Configuration',
        description: 'Configure what information referees will provide',
        buttonText: 'Add Referee Field',
        helpText:
          'Add fields for referees to complete. This information will be collected when referees submit their references online.',
      };
    }

    return {
      title: 'Adding items to your task',
      description: 'Create and customise fields and headings',
      buttonText: 'Add field',
      helpText: null,
    };
  };

  const content = getContent();

  return (
    <Box display='flex' flexDirection='column' justifyContent='center'>
      <Box textAlign='center' paddingY={1} paddingX={1}>
        <Box display='flex' justifyContent='center' alignItems='center' marginBottom={1}>
          {taskType === 'event' && <EventNote style={{ marginRight: 6, color: '#666666', fontSize: '18px' }} />}
          {taskType === 'referee_check' && <Group style={{ marginRight: 6, color: '#666666', fontSize: '18px' }} />}
          <Typography variant='body1' style={{ fontWeight: 'bold' }}>
            {content.title}
          </Typography>
        </Box>

        <Typography variant='body2' color='textSecondary'>
          {content.description}
        </Typography>

        {content.helpText && (
          <Typography variant='caption' color='textSecondary' style={{ marginTop: 8, fontStyle: 'italic' }}>
            {content.helpText}
          </Typography>
        )}
      </Box>

      <Box textAlign='center' marginTop={1} paddingBottom={2} paddingX={1}>
        <TabletButton
          fullWidth
          color='primary'
          variant='contained'
          size='medium'
          onClick={addField}
          style={{ marginBottom: 16 }}
        >
          {content.buttonText}
        </TabletButton>

        <HoverText color='primary' variant='body2' onClick={addHeading} style={{ marginBottom: 16 }}>
          Add heading
        </HoverText>

        <HoverText color='primary' variant='body2' onClick={addContent} style={{ marginBottom: 16 }}>
          Add content
        </HoverText>

        <HoverText color='primary' variant='body2' onClick={addMedia} style={{ marginBottom: 16 }}>
          Add media
        </HoverText>

        <HoverText color='primary' variant='body2' onClick={addPageBreak}>
          Add page break
        </HoverText>
      </Box>
    </Box>
  );
};
interface TaskControlsCardProps {
  taskType?: string;
}

export const TaskControlsCard = ({ taskType }: TaskControlsCardProps) => {
  return (
    <Card>
      <CardContent>
        <TaskControlsContent taskType={taskType} />
      </CardContent>
    </Card>
  );
};
